import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHouse,
  faFileCirclePlus,
  faListCheck,
  faUserGear,
  faUserShield,
  faPenNib,
  faHandHoldingDollar,
  faHandshake,
  faBell,
  faPeopleArrows,
  faPaperclip,
  faBook,
  faFeather,
  faPhone,
  faTheaterMasks,
  faUserTie,
  faRadio,
} from "@fortawesome/free-solid-svg-icons";

<i class="fa-solid fa-people-arrows"></i>;

export const Sidenav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dashboardMenu, setDashBoardMenu] = useState("");
  const [accountMenu, setAccountMenu] = useState("");
  const [paymentMenu, setPaymentMenu] = useState("");
  const [helpMenu, setHelpMenu] = useState("");
  const { pathname } = location;

  const handleDashboardMenu = () => {
    if (dashboardMenu === "open") {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("");
      }, 200);
    } else {
      setDashBoardMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setDashBoardMenu("open");
      }, 200);
    }
  };

  const handleAccountMenu = () => {
    if (accountMenu === "open") {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("");
      }, 200);
    } else {
      setAccountMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setAccountMenu("open");
      }, 200);
    }
  };
  const handlePaymentMenu = () => {
    if (paymentMenu === "open") {
      setPaymentMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setPaymentMenu("");
      }, 200);
    } else {
      setPaymentMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setPaymentMenu("open");
      }, 200);
    }
  };
  const handleHelpMenu = () => {
    if (helpMenu === "open") {
      setHelpMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setHelpMenu("");
      }, 200);
    } else {
      setHelpMenu("menu-item-animating menu-item-closing");
      setTimeout(() => {
        setHelpMenu("open");
      }, 200);
    }
  };
  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme"
    >
      <div className="app-brand demo">
        <Link className="app-brand-link" to="/">
          <span className="app-brand-logo demo">
            <img
              src="../../assets/img/flowersvg.svg"
              style={{
                width: "40px",
                height: "26px",
                borderRadius: "50%",
              }}
            />
          </span>
          <span className="app-brand-text demo menu-text fw-bold ms-0">
            Zenosure
          </span>
        </Link>
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1">
        <li
          className={`menu-item ${
            pathname === "/dashboard" || pathname.startsWith("/dashBEnrollPI")
              ? "active"
              : ""
          }`}
        >
          <Link to="/dashboard" className="menu-link">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faBell} size="xs" className="me-2" />
              Dashboard
            </div>
          </Link>
        </li>
        <li
          className={`menu-item ${
            pathname === "/plans" ||
            pathname.startsWith("/selectedPlan") ||
            pathname.startsWith("/membershipForm")
              ? "active"
              : ""
          }`}
        >
          <Link to="/plans" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon icon={faHouse} size="xs" className="me-2" />
              Plans
            </div>
          </Link>
        </li>

        <li
          className={`menu-item ${
            pathname === "/enrolledPlans" ||
            pathname.startsWith("/enrollApplicationDetailsForm") ||
            pathname.startsWith("/membershipDetails") ||
            pathname.startsWith("/editmembership")
              ? "active"
              : ""
          }`}
        >
          <Link to="/enrolledPlans" className="menu-link ">
            <div data-i18n="Dashboard">
              {" "}
              <FontAwesomeIcon
                icon={faPeopleArrows}
                size="xs"
                className="me-2"
              />
              Your plans
            </div>
          </Link>
        </li>

        <li
          className={`menu-item active ${dashboardMenu} ${
            (pathname === "/profile" || pathname === "/updateProfile") && "open"
          }`}
          onClick={handleDashboardMenu}
        >
          <Link to="javascript:void(0);" className="menu-link menu-toggle">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faUserGear} size="xs" className="me-2" />
              Settings
            </div>
          </Link>
          <ul className="menu-sub" style={{ listStyle: "none" }}>
            <li
              className={`menu-item ${
                pathname === "/profile" || pathname === "/updateProfile"
                  ? "active"
                  : ""
              }`}
            >
              <Link to="/profile" className="menu-link">
                <FontAwesomeIcon icon={faUser} size="xs" className="me-2" />{" "}
                Profile
              </Link>
            </li>
          </ul>
        </li>

        <li
          className={`menu-item active ${accountMenu} ${
            (pathname === "/setPassword" || pathname === "/securityTerms") &&
            "open"
          }`}
          onClick={handleAccountMenu}
        >
          <Link to="javascript:void(0);" className="menu-link menu-toggle">
            <div data-i18n="Account Settings">
              <FontAwesomeIcon icon={faUserShield} size="xs" className="me-2" />{" "}
              Security
            </div>
          </Link>
          <ul className="menu-sub">
            <li
              className={`menu-item ${pathname === "/setPassword" && "active"}`}
            >
              <Link to="/setPassword" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon icon={faPenNib} size="xs" className="me-2" />{" "}
                  Reset password
                </div>
              </Link>
            </li>
          </ul>
        </li>
        <li
          className={`menu-item active ${paymentMenu} ${
            (pathname === "/billing" || pathname === "/invoicerecept") && "open"
          }`}
          onClick={handlePaymentMenu}
        >
          <Link to="javascript:void(0);" className="menu-link  menu-toggle">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon
                icon={faHandHoldingDollar}
                size="xs"
                className="me-2"
              />{" "}
              Manage payments
            </div>
          </Link>
          <ul className="menu-sub">
            <li className={`menu-item ${pathname === "/billing" && "active"}`}>
              <Link to="/billing" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon
                    icon={faFeather}
                    size="xs"
                    className="me-2"
                  />{" "}
                  Billing
                </div>
              </Link>
            </li>
            <li
              className={`menu-item ${
                pathname === "/invoicerecept" && "active"
              }`}
            >
              <Link to="/invoicerecept" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon icon={faBook} size="xs" className="me-2" />{" "}
                  Invoice & receipt
                </div>
              </Link>
            </li>
          </ul>
        </li>
        <li
          className={`menu-item active ${helpMenu} ${
            (pathname === "/contactussid" || pathname === "/faqsid") && "open"
          }`}
          onClick={handleHelpMenu}
        >
          <Link to="javascript:void(0);" className="menu-link menu-toggle">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faHandshake} size="xs" className="me-2" />
              Help
              {/* contactus & faq */}
            </div>
          </Link>
          <ul className="menu-sub">
            <li
              className={`menu-item ${
                pathname === "/contactussid" && "active"
              }`}
            >
              <Link to="/contactussid" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon icon={faPhone} size="xs" className="me-2" />{" "}
                  Contact us
                </div>
              </Link>
            </li>
            <li className={`menu-item ${pathname === "/faqsid" && "active"}`}>
              <Link to="/faqsid" className="menu-link">
                <div data-i18n="Account">
                  <FontAwesomeIcon
                    icon={faUserTie}
                    size="xs"
                    className="me-2"
                  />{" "}
                  FAQ
                </div>
              </Link>
            </li>
          </ul>
        </li>
        <li className={`menu-item `}>
          <Link to="#" className="menu-link ">
            <div data-i18n="Dashboard">
              <FontAwesomeIcon icon={faRadio} size="xs" className="me-2" />{" "}
              Notifications
            </div>
          </Link>
        </li>
      </ul>
    </aside>
  );
};
